/* KLIKSO — landing grebalice: igra sa kaučem, kviz, mačka koja skače po grebalicama, prava korpa. */
(function(){
'use strict';
function kgStart(){
var RT=document.querySelector('[data-kg]'); if(!RT || RT.dataset.kgInit) return; RT.dataset.kgInit='1';
var D={items:[]}; try{ D=JSON.parse(RT.querySelector('[data-kg-data]').textContent); }catch(e){}
var P={mala:[],srednja:[],velika:[]}, T={};
D.items.forEach(function(it){ if(!it || !it.variant || !P[it.size]) return;
var p={h:it.handle,name:it.name||it.title,full:it.title,ht:it.height||'',price:Math.round(it.price/100),img:it.img,variant:it.variant,available:it.available,
facts:[it.f1,it.f2,it.f3].filter(function(x){return x}),mood:it.mood||'love',say:it.say||''};
P[it.size].push(p);
T[p.h]={fit:[+it.q_s||0,+it.q_b||0,+it.q_h||0],cats:+it.q_c||1,climb:+it.q_climb||0,hide:+it.q_hide||0,play:+it.q_play||0,why:it.why||''};
});
var SIZES0 = [
{k:'mala', label:'Mala', sub:'do 80 cm', h:20},
{k:'srednja', label:'Srednja', sub:'130–150 cm i zidni set', h:30},
{k:'velika', label:'Velika', sub:'od 2 m do plafona', h:42}
];
var SIZES=SIZES0.filter(function(s){return P[s.k].length});
var uid=0;
function catInner(){
var p='kgc'+(uid++);
var S='#3F444B';
return ''+
'<defs>'+
'<radialGradient id="'+p+'b" cx=".45" cy=".3" r=".8"><stop offset="0" stop-color="#CDD2D8"/><stop offset=".55" stop-color="#959CA5"/><stop offset="1" stop-color="#5E646C"/></radialGradient>'+
'<radialGradient id="'+p+'h" cx=".5" cy=".38" r=".7"><stop offset="0" stop-color="#D6DBE0"/><stop offset=".6" stop-color="#9DA4AD"/><stop offset="1" stop-color="#646B74"/></radialGradient>'+
'<linearGradient id="'+p+'c" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#FCFCFB"/><stop offset="1" stop-color="#D9DCE0"/></linearGradient>'+
'<radialGradient id="'+p+'i" cx=".5" cy=".5" r=".55"><stop offset="0" stop-color="#F2E27A"/><stop offset=".55" stop-color="#B9C64A"/><stop offset="1" stop-color="#6E7F24"/></radialGradient>'+
'<linearGradient id="'+p+'e" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#D99A90"/><stop offset="1" stop-color="#F3C6BD"/></linearGradient>'+
'<filter id="'+p+'f" x="-10%" y="-10%" width="120%" height="120%"><feTurbulence type="fractalNoise" baseFrequency=".85" numOctaves="2" seed="4"/><feDisplacementMap in="SourceGraphic" scale="3.2"/></filter>'+
'</defs>'+
'<ellipse cx="80" cy="158" rx="50" ry="6" fill="#000" opacity=".16"/>'+
'<g class="ball"><line x1="128" y1="-20" x2="128" y2="84" stroke="#6b6b6b" stroke-width="1.5"/><circle cx="128" cy="90" r="9" fill="#E8463B"/><circle cx="125" cy="87" r="3" fill="#fff" opacity=".5"/></g>'+
'<g class="tail"><path filter="url(#'+p+'f)" d="M108 150 C146 154 160 126 150 98 C147 90 139 92 141 100 C148 120 140 140 108 142 Z" fill="url(#'+p+'b)"/>'+
'<path d="M147 112 l9 1 M146 124 l8 4 M138 136 l5 6" stroke="'+S+'" stroke-width="4" stroke-linecap="round" opacity=".75"/></g>'+
'<path filter="url(#'+p+'f)" d="M42 156 C30 126 40 94 80 90 C120 94 130 126 118 156 Z" fill="url(#'+p+'b)"/>'+
'<g fill="'+S+'" opacity=".7"><path d="M44 116 C52 114 58 116 62 120 C56 120 50 121 45 124 Z"/><path d="M42 132 C50 130 57 132 60 136 C54 136 48 137 43 140 Z"/><path d="M116 116 C108 114 102 116 98 120 C104 120 110 121 115 124 Z"/><path d="M118 132 C110 130 103 132 100 136 C106 136 112 137 117 140 Z"/></g>'+
'<path filter="url(#'+p+'f)" d="M62 96 C70 118 64 140 70 158 L90 158 C96 140 90 118 98 96 C90 104 70 104 62 96 Z" fill="url(#'+p+'c)"/>'+
'<g class="ear-l"><path d="M44 54 C38 36 38 20 43 8 C55 14 67 25 73 34 Z" fill="url(#'+p+'h)"/><path d="M49 45 C46 33 46 24 48 17 C56 22 62 28 66 34 Z" fill="url(#'+p+'e)"/>'+
'<path d="M50 40 l6 -6 M52 44 l7 -4" stroke="#F4F5F6" stroke-width="1.2" stroke-linecap="round"/></g>'+
'<path d="M116 54 C122 36 122 20 117 8 C105 14 93 25 87 34 Z" fill="url(#'+p+'h)"/><path d="M111 45 C114 33 114 24 112 17 C104 22 98 28 94 34 Z" fill="url(#'+p+'e)"/>'+
'<path d="M110 40 l-6 -6 M108 44 l-7 -4" stroke="#F4F5F6" stroke-width="1.2" stroke-linecap="round"/>'+
'<path filter="url(#'+p+'f)" d="M80 22 C104 22 121 36 123 57 C132 64 129 76 120 80 C112 92 98 99 80 99 C62 99 48 92 40 80 C31 76 28 64 37 57 C39 36 56 22 80 22 Z" fill="url(#'+p+'h)"/>'+
'<g stroke="'+S+'" stroke-linecap="round" fill="none" opacity=".8"><path d="M80 25 V40" stroke-width="3.4"/><path d="M71 27 C72 33 73 37 75 42" stroke-width="3"/><path d="M89 27 C88 33 87 37 85 42" stroke-width="3"/>'+
'<path d="M62 31 C64 36 66 39 69 42" stroke-width="2.4"/><path d="M98 31 C96 36 94 39 91 42" stroke-width="2.4"/>'+
'<path d="M36 64 C44 63 50 65 55 68" stroke-width="2.8"/><path d="M38 72 C45 71 50 73 54 75" stroke-width="2.4"/><path d="M124 64 C116 63 110 65 105 68" stroke-width="2.8"/><path d="M122 72 C115 71 110 73 106 75" stroke-width="2.4"/></g>'+
'<g filter="url(#'+p+'f)" fill="url(#'+p+'c)"><ellipse cx="71" cy="77" rx="11.5" ry="9"/><ellipse cx="89" cy="77" rx="11.5" ry="9"/><ellipse cx="80" cy="87" rx="9" ry="6.5"/></g>'+
'<g class="eyes">'+
'<path d="M55 58 C60 49 72 49 77 58 C72 65 60 65 55 58 Z" fill="url(#'+p+'i)" stroke="#1E2125" stroke-width="1.8"/>'+
'<path d="M83 58 C88 49 100 49 105 58 C100 65 88 65 83 58 Z" fill="url(#'+p+'i)" stroke="#1E2125" stroke-width="1.8"/>'+
'<g class="pupil"><ellipse cx="66" cy="57.5" rx="2.4" ry="6" fill="#0E0F10"/><ellipse cx="94" cy="57.5" rx="2.4" ry="6" fill="#0E0F10"/>'+
'<circle cx="68.5" cy="54.5" r="1.7" fill="#fff"/><circle cx="96.5" cy="54.5" r="1.7" fill="#fff"/></g></g>'+
'<g class="shut" stroke="#1E2125" stroke-width="2.4" stroke-linecap="round" fill="none"><path d="M57 59 q9 5 18 0"/><path d="M85 59 q9 5 18 0"/></g>'+
'<path d="M74.5 69 C74.5 66.5 85.5 66.5 85.5 69 C85.5 72 82.5 74 80 75.5 C77.5 74 74.5 72 74.5 69 Z" fill="#D9928A" stroke="#8E5750" stroke-width="1"/>'+
'<path d="M80 75.5 v3 M80 78.5 q-4 4 -8 1.4 M80 78.5 q4 4 8 1.4" fill="none" stroke="#3C3F44" stroke-width="1.4" stroke-linecap="round"/>'+
'<g stroke="#FFFFFF" stroke-width=".9" stroke-linecap="round" opacity=".95"><path d="M64 78 C52 75 42 74 30 75"/><path d="M64 81 C52 81 42 83 32 86"/><path d="M65 84 C55 86 46 90 38 95"/><path d="M96 78 C108 75 118 74 130 75"/><path d="M96 81 C108 81 118 83 128 86"/><path d="M95 84 C105 86 114 90 122 95"/></g>'+
'<g class="paw-l"><ellipse cx="65" cy="151" rx="12.5" ry="7.5" fill="url(#'+p+'c)"/><path d="M60 149 v4 M65 148.5 v4.5 M70 149 v4" stroke="#9EA4AB" stroke-width="1.3" stroke-linecap="round"/></g>'+
'<g class="paw-r"><ellipse cx="95" cy="151" rx="12.5" ry="7.5" fill="url(#'+p+'c)"/><path d="M90 149 v4 M95 148.5 v4.5 M100 149 v4" stroke="#9EA4AB" stroke-width="1.3" stroke-linecap="round"/></g>'+
'<g class="scr" stroke="#8D7A62" stroke-width="2" stroke-linecap="round"><path d="M57 160 l-3 9"/><path d="M64 160 l-3 9"/><path d="M96 160 l3 9"/><path d="M103 160 l3 9"/></g>'+
'<g class="zzz" fill="#4A524C" font-family="DM Sans,Arial,sans-serif" font-weight="800"><text x="118" y="30" font-size="17">z</text><text x="128" y="18" font-size="13">z</text><text x="136" y="8" font-size="10">z</text></g>'+
'<g class="hearts" fill="#F07C93"><path d="M124 30 c-4 -6 -12 -2 -8 5 l8 7 l8 -7 c4 -7 -4 -11 -8 -5z"/><path d="M140 14 c-3 -4 -9 -1 -6 4 l6 5 l6 -5 c3 -5 -3 -8 -6 -4z"/><path d="M30 24 c-3 -4 -9 -1 -6 4 l6 5 l6 -5 c3 -5 -3 -8 -6 -4z"/></g>';
}
function catSVG(id){ return '<svg class="cat" viewBox="0 0 160 170" aria-hidden="true" id="kg-'+id+'">'+catInner()+'</svg>'; }
var $=function(id){return document.getElementById('kg-'+id)};
var NS='http://www.w3.org/2000/svg';
var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }
function rsd(n){return String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'.')}
function hdrH(){ var h=document.querySelector('sticky-header, .section-header, header'); if(!h) return 0; var r=h.getBoundingClientRect(); return (r.bottom>0 && r.top<=1)? Math.min(r.bottom,140):0; }
function scrollToEl(el){
var off=hdrH()+12; var top=el.getBoundingClientRect().top + (window.pageYOffset||document.documentElement.scrollTop||0) - off;
var se=document.scrollingElement||document.documentElement;
try{ window.scrollTo({top:top,behavior:reduce?'auto':'smooth'}); }catch(e){ window.scrollTo(0,top); }
setTimeout(function(){ if(Math.abs(el.getBoundingClientRect().top-off)>40){ se.scrollTop=top; document.body.scrollTop=top; } },700);
}
var busy=false, tT;
function toast(t){ $('toastTxt').textContent=t; $('toast').classList.add('show'); clearTimeout(tT); tT=setTimeout(function(){$('toast').classList.remove('show')},2400); }
var hc=document.createElementNS(NS,'g'); hc.setAttribute('class','cat'); hc.id='kg-heroCat';
$('heroCatPos').appendChild(hc);
hc.innerHTML=catInner();
var scene=$('scene'), claws=$('claws'), laser=$('laser'), hits=0, MAX=1, done=false;
var SPOTS=[[300,260],[640,250],[420,380],[760,390],[220,410],[560,420],[700,300],[180,300],[860,420],[380,300]];
var lastSpot=-1;
function svgPt(e){ var pt=scene.createSVGPoint(); pt.x=e.clientX; pt.y=e.clientY; return pt.matrixTransform(scene.getScreenCTM().inverse()); }
function rnd(a,b){return a+Math.random()*(b-a)}
function gougePath(x0,len,w,bend){
var N=10, L=[], R=[];
for(var i=0;i<=N;i++){
var t=i/N, y=t*len, x=x0+bend*Math.sin(t*Math.PI*.9)+t*bend*.4, hw=w*Math.sin(Math.PI*Math.min(1,t*1.05))*(1-t*.25);
L.push((x-hw).toFixed(1)+' '+y.toFixed(1)); R.unshift((x+hw).toFixed(1)+' '+y.toFixed(1));
}
return 'M'+L.join(' L')+' L'+R.join(' L')+' Z';
}
function addScratch(x,y){
var g=document.createElementNS(NS,'g');
g.setAttribute('class','scr-g');
var rot=rnd(-28,12), sc=rnd(2.5,2.9);
g.setAttribute('transform','translate('+x.toFixed(0)+' '+Math.min(Math.max(y-120,180),300).toFixed(0)+') rotate('+rot.toFixed(1)+') scale('+sc.toFixed(2)+')');
var html='', offs=[-22,-7,8,22], bend=rnd(-7,7);
offs.forEach(function(o,i){
var len=rnd(70,96)-(i===0||i===3?14:0), top=(i===0||i===3)?8:0;
var d=gougePath(o,len,rnd(2.6,3.6),bend);
html+='<g class="gouge" transform="translate(0 '+top+')">'+
'<path d="'+d+'" fill="#0E3A10" opacity=".55" transform="translate(1.6 1.8)"/>'+
'<path d="'+d+'" fill="#64D565"/>'+
'<path d="'+gougePath(o,len,1.1,bend)+'" fill="#2E9B30" opacity=".8"/></g>';
});
for(var k=0;k<5;k++){
var fx=rnd(-26,26), fy=rnd(60,100);
html+='<path class="fib" d="M'+fx.toFixed(0)+' '+fy.toFixed(0)+' q'+rnd(-5,5).toFixed(0)+' '+rnd(4,8).toFixed(0)+' '+rnd(-7,7).toFixed(0)+' '+rnd(9,14).toFixed(0)+'" stroke="#9BE89C" stroke-width="1.6" fill="none" stroke-linecap="round" style="animation-delay:'+(.15+k*.04).toFixed(2)+'s"/>';
}
g.innerHTML=html;
claws.appendChild(g);
}
function lookAt(x,y){
var dx=Math.max(-1,Math.min(1,(x-910)/400)), dy=Math.max(-1,Math.min(1,(y-80)/300));
var pu=hc.querySelector('.pupil'); if(pu) pu.setAttribute('transform','translate('+(dx*2.6).toFixed(1)+' '+(dy*2.4).toFixed(1)+')');
}
function moveLaser(){
if(done){ laser.setAttribute('hidden',''); return; }
var i; do{ i=Math.floor(Math.random()*SPOTS.length); }while(i===lastSpot);
lastSpot=i;
laser.setAttribute('transform','translate('+SPOTS[i][0]+' '+SPOTS[i][1]+')');
laser.removeAttribute('hidden');
laser.classList.remove('hop'); void laser.getBBox(); laser.classList.add('hop');
lookAt(SPOTS[i][0],SPOTS[i][1]);
}
var LINES=[
'Ups. Vidite onu šapicu na kauču? Dodirnite je i mačka kreće ponovo!',
'Još jednom! Šapica beži, a kauč trpi.',
'Mačka se tek zagrejala. Gde je sad šapica?',
'Kauč je na izdisaju. Još jedna ogrebotina...'
];
function scratchAt(x,y){
if(done) return;
$('hint').hidden=true;
hits++;
addScratch(x,y);
hc.classList.remove('swipe'); void hc.getBBox(); hc.classList.add('swipe');
var hp=Math.round(Math.max(0,100-hits*(100/MAX)));
$('meterFill').style.width=hp+'%'; $('meterTxt').textContent=hp+'%';
$('score').textContent='Ogrebotine: '+hits;
$('hud').classList.toggle('low',hp<50);
if(hits<MAX){
$('heroLead').textContent=LINES[Math.min(hits-1,LINES.length-1)];
setTimeout(moveLaser, reduce?0:350);
} else {
done=true; laser.setAttribute('hidden','');
var _kt='Kauč je izgubio. <em>Mačka traži svoje mesto.</em>';
var _kl='Mačka ne grebe iz inata, nego zato što mora. Dajte joj grebalicu: ona je srećna, a kauč ostaje ceo.';
$('heroBtn').classList.add('pulse');
hc.classList.add('m-love');var kgS=document.createElement('p');kgS.className='kg-save';kgS.textContent='Sačuvajte vaš nameštaj i usrećite mačku';scene.parentNode.appendChild(kgS);
}
}
scene.addEventListener('pointerdown',function(e){
var t=e.target;
if(t.closest && t.closest('#kg-laser')){ var tr=laser.getAttribute('transform').match(/translate\(([\d.]+) ([\d.]+)\)/); scratchAt(+tr[1],+tr[2]); return; }
if(t.id==='kg-hit'){ var q=svgPt(e); scratchAt(q.x,q.y); }
});
scene.addEventListener('pointermove',function(e){ if(!laser.hasAttribute('hidden')) return; var p=svgPt(e); lookAt(p.x,p.y); });
$('heroBtn').addEventListener('click',function(){ scrollToEl($('izbor')); });
function sizeIcon(h){
var y=40-h;
return '<svg viewBox="0 0 30 42" aria-hidden="true">'+
'<rect x="11" y="'+(y+3)+'" width="6" height="'+(h-5)+'" rx="2" fill="#E7D8BC" stroke="#121513" stroke-width="1.8"/>'+
'<rect x="5" y="'+y+'" width="18" height="5" rx="2" fill="#8A938C" stroke="#121513" stroke-width="1.8"/>'+
'<rect x="4" y="35" width="22" height="6" rx="2" fill="#8A938C" stroke="#121513" stroke-width="1.8"/></svg>';
}
function minPrice(k){ return Math.min.apply(null,P[k].map(function(p){return p.price})); }
var sizesEl=$('sizes'), cur=(P.srednja.length?'srednja':'mala'), idx=0, seen={};
SIZES.forEach(function(s){
var b=document.createElement('button'); b.type='button'; b.className='size'; b.dataset.k=s.k;
b.setAttribute('aria-pressed', String(s.k===cur));
b.innerHTML='<span class="size-ico">'+sizeIcon(s.h)+'</span><b>'+s.label+'</b><span>'+s.sub+'</span><small>od <strong>'+rsd(minPrice(s.k))+' RSD</strong></small>';
b.addEventListener('click',function(){ setSize(s.k,true); });
sizesEl.appendChild(b);
});
var track=$('track'), dots=$('dots'), rider=$('rider'), bubble=$('bubble');
$('riderCat').innerHTML=catSVG('rideCat');
var rideCat=$('rideCat');
var ARR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">';
var CHK='<span class="k-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>';
function nextSizeLabel(){ var ks=SIZES.map(function(s){return s.k}); var n=SIZES[(ks.indexOf(cur)+1)%ks.length]; return n.label+' grebalice'; }
function cardHTML(p,i,n){
var last=i===n-1;
return '<article class="card" aria-roledescription="slajd" aria-label="'+(i+1)+' od '+n+'">'+
'<div class="card-img"><img src="'+p.img+'" alt="'+esc(p.full)+'" loading="'+(i?'lazy':'eager')+'" width="600" height="600">'+
'<span class="num">Grebalica '+(i+1)+' od '+n+'</span>'+
'<span class="hbadge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 3v18M8 7l4-4 4 4M8 17l4 4 4-4"/></svg>'+p.ht+'</span></div>'+
'<div class="card-body"><h3>'+esc(p.name)+'</h3><p class="full">'+esc(p.full)+'</p>'+
'<ul class="facts">'+p.facts.map(function(f){return '<li>'+CHK+f+'</li>'}).join('')+'</ul>'+
'<div class="buy"><div class="k-price">'+rsd(p.price)+'<small>RSD</small><span class="cod">Plaćanje pouzećem</span></div>'+
(p.available?'':'<span class="cod">Trenutno nije na stanju</span>')+'<button class="k-btn k-btn-primary add" type="button" data-i="'+i+'"'+(p.available?'':' disabled')+'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6.2"/></svg>Dodaj u korpu</button></div>'+
'</div>'+
'<button class="snav prev" type="button" aria-label="Prethodna grebalica"'+(i===0?' hidden':'')+'>'+ARR+'<path d="M15 6l-6 6 6 6"/></svg></button>'+
'<button class="snav next'+(i===0?' pulse':'')+'" type="button" aria-label="'+(last?nextSizeLabel():'Sledeća grebalica')+'">'+ARR+'<path d="M9 6l6 6-6 6"/></svg></button>'+
'</article>';
}
function setSize(k,scroll){
cur=k; idx=0;
Array.prototype.forEach.call(sizesEl.children,function(b){b.setAttribute('aria-pressed',String(b.dataset.k===k))});
var list=P[k];
track.style.transition='none';
track.innerHTML=list.map(function(p,i){return cardHTML(p,i,list.length)}).join('');
dots.innerHTML=list.map(function(p,i){return '<button class="dot" type="button" aria-label="'+p.name+'" data-i="'+i+'"><img src="'+p.img+'" alt="" loading="lazy"></button>'}).join('');
void track.offsetWidth; track.style.transition='';
go(0,true);
if(scroll) scrollToEl($('scena'));
}
function setMood(m){ rideCat.setAttribute('class','cat m-'+m); }
var side='l';
function placeRider(i){
var w=$('stage').clientWidth, rw=rider.offsetWidth, wide=w>=860, x;
if(wide){ var XS=[0.04,0.24,0.10,0.30]; x=XS[i%XS.length]*w; side='l'; }
else { side = (i%2===0)?'l':'r'; x = side==='l' ? 4 : (w-rw-4); }
rider.style.transform='translateX('+x.toFixed(0)+'px)';
var room = side==='l' ? (w - x - rw + 6) : (x + 6);
bubble.style.maxWidth=Math.max(140,Math.min(wide?300:room-4,room-4))+'px';
bubble.classList.toggle('l',side==='l'); bubble.classList.toggle('r',side==='r');
if(side==='l'){ bubble.style.left=(rw-6)+'px'; bubble.style.right='auto'; }
else { bubble.style.right=(rw-6)+'px'; bubble.style.left='auto'; }
}
var bT, goT, catName='';
function say(t){ bubble.classList.remove('show'); clearTimeout(bT); bT=setTimeout(function(){
bubble.textContent='';
if(catName){ var w=document.createElement('span'); w.className='who'; w.textContent=catName; bubble.appendChild(w); }
bubble.appendChild(document.createTextNode(t)); bubble.classList.add('show');
},reduce?0:560); }
function updHappy(){
var list=P[cur], n=0; list.forEach(function(p){ if(seen[p.h]) n++; });
$('happyTxt').textContent=(catName? catName+': isprobano ' : 'Mačka je isprobala ')+n+' od '+list.length;
$('happyFill').style.width=(n/list.length*100)+'%';
return n===list.length;
}
function go(i,first){
var list=P[cur]; i=Math.max(0,Math.min(list.length-1,i));
var changed = i!==idx || first;
idx=i;
track.style.transform='translateX('+(-100*i)+'%)';
Array.prototype.forEach.call(dots.children,function(d,j){d.setAttribute('aria-current',String(j===i))});
if(changed && !reduce && !first){ rider.classList.remove('jump'); void rider.offsetWidth; rider.classList.add('jump'); }
setMood('none');
bubble.classList.remove('show');
placeRider(i);
updBar(); setTimeout(updBar,750);
var p=list[i];
clearTimeout(goT); clearTimeout(bT);
goT=setTimeout(function(){
setMood(p.mood);
seen[p.h]=1;
updHappy();
say(p.say);
}, (first||reduce)?0:650);
}
function nextSize(){ var ks=SIZES.map(function(s){return s.k}); setSize(ks[(ks.indexOf(cur)+1)%ks.length],false); }
track.addEventListener('click',function(e){
var nb=e.target.closest('.snav');
if(nb){
if(nb.classList.contains('prev')) go(idx-1);
else if(idx===P[cur].length-1) nextSize();
else go(idx+1);
return;
}
var b=e.target.closest('.add'); if(!b) return;
addToCart(P[cur][+b.dataset.i], b);
});
function themeCart(){ return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
function addToCart(p, btn){
if(!p || !p.available || busy) return;
busy=true; var lbl=btn?btn.innerHTML:''; if(btn){ btn.disabled=true; btn.textContent='Dodajem…'; }
var cartEl=themeCart(), body={id:+p.variant,quantity:1};
if(cartEl && typeof cartEl.getSectionsToRender==='function'){ body.sections=cartEl.getSectionsToRender().map(function(s){return s.id}); body.sections_url=window.location.pathname; }
var root=(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/');
fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
.then(function(r){ return r.json().then(function(d){ return {ok:r.ok,data:d}; }); })
.then(function(res){
if(!res.ok) throw new Error(res.data.description||res.data.message||'Proizvod trenutno nije moguće dodati u korpu.');
setMood('love'); say('Hvala! Već se radujem novoj grebalici.');
toast(p.name+' je u korpi.'+(catName?' '+catName+' će se obradovati!':''));
if(cartEl && typeof cartEl.renderContents==='function'){
cartEl.classList.remove('is-empty'); cartEl.renderContents(res.data);
if(typeof window.publish==='function' && window.PUB_SUB_EVENTS){ window.publish(window.PUB_SUB_EVENTS.cartUpdate,{source:'klikso-grebalice',productVariantId:+p.variant,cartData:res.data}); }
} else { setTimeout(function(){ window.location.href=root+'cart'; },900); }
})
.catch(function(err){ toast(err.message); })
.then(function(){ busy=false; if(btn){ btn.disabled=false; btn.innerHTML=lbl; } });
}
var sbar=$('sbar');
function updBar(){
var p=P[cur][idx]; if(!p) return;
$('sbImg').src=p.img; $('sbName').textContent=p.name; $('sbPrice').innerHTML=rsd(p.price)+'<small>RSD</small>'; $('sbBtn').disabled=!p.available;
var card=track.children[idx], buy=card && card.querySelector('.buy');
var vh=window.innerHeight||document.documentElement.clientHeight;
var heroB=RT.querySelector('.k-hero').getBoundingClientRect().bottom;
var show=heroB < vh*0.45;
if(show && buy){ var r=buy.getBoundingClientRect(); if(r.top < vh-70 && r.bottom > 60) show=false; }
sbar.classList.toggle('show',show); RT.classList.toggle('has-sbar',show);
sbar.setAttribute('aria-hidden',String(!show)); $('sbBtn').tabIndex=show?0:-1;
}
$('sbBtn').addEventListener('click',function(){ addToCart(P[cur][idx], $('sbBtn')); });
window.addEventListener('scroll',updBar,{passive:true});
window.addEventListener('resize',updBar);
dots.addEventListener('click',function(e){var d=e.target.closest('.dot'); if(d) go(+d.dataset.i);});
var sx=null, sy=null;
$('viewport').addEventListener('pointerdown',function(e){ if(e.target.closest('button')) return; sx=e.clientX; sy=e.clientY; });
window.addEventListener('pointerup',function(e){
if(sx===null) return; var dx=e.clientX-sx, dy=e.clientY-sy; sx=null;
if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) go(idx+(dx<0?1:-1));
});
document.addEventListener('keydown',function(e){
if(e.target.closest && e.target.closest('input,textarea,select,[contenteditable]')) return;
var r=$('stage').getBoundingClientRect(); if(r.bottom<0 || r.top>window.innerHeight) return;
if(e.key==='ArrowRight') go(idx+1); if(e.key==='ArrowLeft') go(idx-1);
});
window.addEventListener('resize',function(){ placeRider(idx); });
function setName(n){
catName=(n||'').replace(/\s+/g,' ').trim().slice(0,18);
try{ if(catName) localStorage.setItem('klikso-cat',catName); else localStorage.removeItem('klikso-cat'); }catch(e){}
var tag=$('nameTag');
if(catName){ tag.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="12" cy="16" rx="5" ry="4"/><circle cx="6" cy="10" r="2"/><circle cx="10" cy="6.5" r="2"/><circle cx="14" cy="6.5" r="2"/><circle cx="18" cy="10" r="2"/></svg>'; tag.appendChild(document.createTextNode(catName)); tag.hidden=false; }
else tag.hidden=true;
updHappy();
}
var IC={
flat:'<path d="M5 21V8l7-5 7 5v13"/><path d="M9 21v-6h6v6"/>',
big:'<path d="M3 21V9l6-4 6 4v12"/><path d="M15 21V12l6 0v9"/><path d="M7 13h4"/>',
house:'<path d="M3 11l9-8 9 8"/><path d="M5 9v12h14V9"/><path d="M10 21v-5h4v5"/>',
one:'<circle cx="12" cy="12" r="3.5"/>',
two:'<circle cx="8" cy="12" r="3"/><circle cx="16" cy="12" r="3"/>',
three:'<circle cx="6" cy="13" r="2.6"/><circle cx="12" cy="9" r="2.6"/><circle cx="18" cy="13" r="2.6"/>',
climb:'<path d="M12 3v18"/><path d="M7 7h10M7 12h10M7 17h10"/>',
hide:'<path d="M4 20V10l8-6 8 6v10z"/><path d="M9.5 20v-4a2.5 2.5 0 0 1 5 0v4"/>',
play:'<circle cx="12" cy="15" r="5"/><path d="M12 3v7"/>'
};
function ico(k){ return '<span class="ic"><svg viewBox="0 0 24 24" fill="none" stroke="#2E9B30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+IC[k]+'</svg></span>'; }
var QS=[
{q:'Gde živi vaša mačka?', k:'home', o:[['flat','Manji stan','do 50 m²'],['big','Veći stan','više prostora'],['house','Kuća','ima mesta na pretek']]},
{q:'Koliko mačaka imate?', k:'cats', o:[['one','Jednu',''],['two','Dve',''],['three','Tri ili više','']]},
{q:'Šta vaša mačka najviše voli?', k:'like', o:[['climb','Da se penje visoko','i gleda odozgo'],['hide','Da se krije i spava','u svom kutku'],['play','Da se igra','loptice i igračke']]}
];
var LIKE=['climb','hide','play'], ans={}, qi=0;
function prog(n){ $('qzProg').innerHTML=[0,1,2].map(function(i){return '<i class="'+(i<n?'on':'')+'"></i>'}).join(''); }
function qzName(){
$('qzLabel').textContent='Za početak';
prog(0);
$('qzStep').innerHTML='<h3>Kako se zove vaša mačka?</h3>'+
'<form class="qz-name" id="kg-qzNameF"><input id="kg-qzNameIn" type="text" maxlength="18" autocomplete="off" placeholder="npr. Mici" aria-label="Ime mačke"><button class="k-btn k-btn-primary" type="submit">Dalje</button></form>'+
'<button class="qz-skip" type="button" id="kg-qzSkip">Preskoči</button>';
var inp=$('qzNameIn'); inp.value=catName||'';
$('qzNameF').addEventListener('submit',function(e){ e.preventDefault(); setName(inp.value); qi=0; qzQ(); });
$('qzSkip').addEventListener('click',function(){ qi=0; qzQ(); });
setTimeout(function(){ try{ inp.focus({preventScroll:true}); }catch(e){} },50);
}
function qzQ(){
var Q=QS[qi];
$('qzLabel').textContent='Pitanje '+(qi+1)+' od 3';
prog(qi);
var title=Q.q; if(catName && Q.k==='like') title='Šta '+catName+' najviše voli?';
$('qzStep').innerHTML='<h3>'+title.replace(/</g,'&lt;')+'</h3><div class="qz-opts">'+
Q.o.map(function(o,i){return '<button class="qz-opt" type="button" data-i="'+i+'">'+ico(o[0])+'<span>'+o[1]+(o[2]?'<small>'+o[2]+'</small>':'')+'</span></button>'}).join('')+'</div>';
}
$('qzStep').addEventListener('click',function(e){
var b=e.target.closest('.qz-opt'); if(!b) return;
ans[QS[qi].k]=+b.dataset.i;
qi++;
if(qi<QS.length) qzQ(); else qzResult();
});
function pick(){
var all=[];
Object.keys(P).forEach(function(k){ P[k].forEach(function(p,i){
var t=T[p.h], s=t.fit[ans.home]*2;
if(ans.cats===1) s+= t.cats>=2?2:-3;
if(ans.cats===2) s+= t.cats>=3?4:(t.cats>=2?1:-4);
s+= t[LIKE[ans.like]]*2;
all.push({k:k,i:i,p:p,s:s});
}); });
all.sort(function(a,b){ return (b.s-a.s) || (a.p.price-b.p.price); });
return all;
}
var rec=null, alt=null;
function qzResult(){
var ranked=pick(); rec=ranked[0]; alt=ranked[1]; var p=rec.p;
prog(3); $('qzLabel').textContent='Gotovo!';
var head=catName? catName.replace(/</g,'&lt;')+', ovo je tvoja grebalica!' : 'Ovo je grebalica za vašu mačku!';
$('qzStep').innerHTML='<div class="qz-kicker">Mačka je izabrala</div>'+
'<div class="qz-res"><img src="'+p.img+'" alt="'+esc(p.full)+'"><div><h3>'+head+'</h3><p><b>'+p.name+'</b> ('+p.ht+'): '+T[p.h].why+'.</p><b class="k-price">'+rsd(p.price)+'<small>RSD</small></b></div></div>'+
'<div class="qz-acts"><button class="k-btn k-btn-primary" type="button" id="kg-qzSee">Pogledaj grebalicu</button><button class="qz-skip" type="button" id="kg-qzAlt">Druga opcija: '+alt.p.name+'</button><button class="qz-skip" type="button" id="kg-qzAgain">Ponovi kviz</button></div>';
$('qzSee').addEventListener('click',function(){
setSize(rec.k,false);
if(rec.i) go(rec.i);
scrollToEl($('scena'));
});
$('qzAgain').addEventListener('click',function(){ ans={}; qi=0; qzQ(); });
$('qzAlt').addEventListener('click',function(){ setSize(alt.k,false); if(alt.i) go(alt.i); scrollToEl($('scena')); });
}
function startQuiz(){
$('qzIntro').hidden=true; $('qzBody').hidden=false;
ans={}; qi=0;
if(catName){ qzQ(); } else qzName();
}
$('qzStart').addEventListener('click',startQuiz);
$('heroQuiz').addEventListener('click',function(){ startQuiz(); scrollToEl($('quiz')); });
$('qzCat').innerHTML=catSVG('qzCatSvg');
$('qzCatSvg').setAttribute('class','cat m-play');
var all=[]; SIZES.forEach(function(s){ all=all.concat(P[s.k]); });
if(all.length){ var mn=Math.min.apply(null,all.map(function(p){return p.price})); var hn=$('heroNote'); if(hn) hn.innerHTML='Već od <b>'+rsd(mn)+' RSD</b> · '+all.length+' modela za svaku mačku'; }
if(!P[cur].length && SIZES.length) cur=SIZES[0].k;
if(!SIZES.length) return;
setSize(cur,false);
try{ var sv=localStorage.getItem('klikso-cat'); if(sv) setName(sv); }catch(e){}
lookAt(500,400);
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',kgStart); else kgStart();
document.addEventListener('shopify:section:load',function(){ var r=document.querySelector('[data-kg]'); if(r){ r.dataset.kgInit=''; kgStart(); } });
})();